import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { WorkflowTransition, WorkflowTransitionCreate, WorkflowTransitionFilter } from '../data/workflowTransition';

export function createWorkflowTransitionService(client: AxiosInstance) {
  return createCrudService<WorkflowTransition, WorkflowTransitionCreate, WorkflowTransitionFilter>(
    client,
    '/workflow/WorkflowTransition',
    'id',
  );
}

export type WorkflowTransitionService = CrudService<WorkflowTransition, WorkflowTransitionCreate, WorkflowTransitionFilter>;
